import { atom } from 'recoil';

export interface BoxEvent {
	eIdx: number;
	name: string;
	type: string;
	beginDt: string;
	endDt: string;
	discount: number; // percent
}

const BoxEventItem = atom<BoxEvent | null>({
	key: 'BoxEvent',
	default: null,
});

// 상자 가격 기준
const GoldBoxPrice = atom({
	key: 'GoldBoxPrice',
	default: 50000,
	// default: 1000, // test
});

const SilverBoxPrice = atom({
	key: 'SilverBoxPrice',
	default: 30000,
});
// 배송비 가격 기준
const DeliveryPrice = atom({
	key: 'DeliveryPrice',
	default: 15000,
	// default: 1500, // test
});
// 분해 반환 포인트 비율
const DecompositionRate = atom({
	key: 'DecompositionRate',
	default: 0.5,
});
// 뉴스룸 등록 가격 기준
const NewsPrice = atom({
	key: 'NewsPrice',
	default: 50000,
});
// 뉴스룸 내 강조 가격 기준
const EmphasizePrice1 = atom({
	key: 'EmphasizePrice1',
	// default: 80000, // Test
	default: 300000,
});
// 뉴스룸 내 강조 가격 기준
const EmphasizePrice2 = atom({
	key: 'EmphasizePrice2',
	// default: 100000, // Test
	default: 10000000,
});
const InspectionAtom = atom({
	key: 'isInspection',
	default: { useYn: '0', message: '' },
});
const LoadingAtom = atom({
	key: 'isLoading',
	default: false,
});
const IsLoginAtom = atom({
	key: 'isLogin',
	default: false,
});
const IsOverlapAtom = atom({
	key: 'isOverlap',
	default: false,
});
const UserLocationAtom = atom({
	key: 'userLocation',
	default: { latitude: null, longitude: null },
});
const UserAtom = atom({
	key: 'UserAtom',
	default: {
		mmIdx: 0,
		joinChannelCode: '', // 가입 경로 코드
		name: '',
		phoneNumber: '',
		email: '',
		pw: '',
		nick: '',
		profileImageUrl: '',
		stateCode: '', // 회원 상태 코드
		gradeCode: '', // 회원 등급 코드
		userExp: '', // 경험치
		freePoint: 0,
		useAgreeYn: '', // 이용 약관 동의
		financialAgreeYn: '', // 전자금융 거래 이용 약관 동의
		privacyAgreeYn: '', // 개인정보 수집 이용 동의
		smsSendYn: 0,
		pushSendYn: 0,
		mailSendYn: 0,
		ageOverYn: '만 14세이상 여부 확인',
		joinDt: '회원 가입 일시',
		joinIp: '회원 가입 IP',
		modDt: '회원 정보 수정 일시',
		modIp: '회원 정보 수정 IP',
		leaveDt: '회원 탈퇴 일시',
		leaveIp: '회원 탈퇴 IP',
		goldboxCnt: 0,
		silverboxCnt: 0,
		loginType: '로그인 타입 키워드(apple)',
		loginTypeCode: '로그인 타입 코드(4 = apple)',
		uid: '로그인 서비스 제공 일련번호',
		referralCode: '추천 코드',
	},
});
const NickChangeCount = atom({
	key: 'NickChangeCount',
	default: 0,
});
// 배송완료 처리를 위한 atom
const DeliveryRequest = atom({
	key: 'DeliveryRequest',
	default: false,
});

export {
	GoldBoxPrice,
	SilverBoxPrice,
	DeliveryPrice,
	DecompositionRate,
	NewsPrice,
	EmphasizePrice1,
	EmphasizePrice2,
	InspectionAtom,
	LoadingAtom,
	IsLoginAtom,
	IsOverlapAtom,
	UserLocationAtom,
	UserAtom,
	NickChangeCount,
	DeliveryRequest,
	BoxEventItem,
};

